module.exports = __webpack_public_path__ + "static/media/MariaSchirattiToniolo.96c106d5.jpg";